import { SectionHead, FadeUp } from "./Reveal";

const WALLS = [
  {
    label: "On stage & tour",
    testid: "proof-wall-artists",
    names: ["Post Malone", "21 Savage", "Justin Bieber", "H.E.R", "Sean Paul", "Odesza", "Wu-Tang Clan", "Becky G", "Khalid", "Backstreet Boys", "Greta Van Fleet", "Bring Me The Horizon", "Walk Off The Earth", "Blue Rodeo", "Divine Brown", "Daya", "Kranium", "Sofi Tukker", "DJ Marley Waters", "Commissioner Gordon", "White Tiger Society", "…just to name a few, and more."],
  },
  {
    label: "Athletes",
    testid: "proof-wall-athletes",
    names: ["Sam Dalembert — NBA", "DeMarcus Ware — NFL", "Guillaume Cizeron — Olympic, 3× World & 4× European gold medalist", "and more"],
  },
  {
    label: "Screen & stage",
    testid: "proof-wall-actors",
    names: ["Taika Waititi", "Lamar Johnson", "Adrian Holmes", "Kota Eberhardt", "Yvonne Zime", "Briar Nolet", "Jordan Clark", "Victoria Baldesarra", "Trevor Tordjman", "Brittany Raymond", "Myles Erlick", "Taveeta Sizinga", "Shane Harte", "and more"],
  },
  {
    label: "TV & tours",
    testid: "proof-wall-tv",
    names: ["The Next Step (2014–2022)", "Disney's The Next Step", "Backstage", "World of Dance", "Big Ticket (2015–2016)", "Post Malone's Beerbongs & Bentleys Tour (2018)", "21 Savage Tour (2018)", "Justin Bieber's Purpose Tour", "Khalid's Freedom Tour", "and more"],
  },
  {
    label: "Events & tournaments",
    testid: "proof-wall-events",
    names: ["World Series of Poker (WSOP) — chair massage", "Major poker tournaments & events, since 2021"],
  },
  {
    label: "Corporate",
    testid: "proof-wall-corporate",
    names: ["BioWare", "and more"],
  },
];

const SHOTS = [
  { src: "/images/t_livenation.jpg", cap: "Live Nation touring credential — on file", tid: "proof-photo-livenation", cls: "h-56 w-full object-cover object-center" },
  { src: "/images/t_mega.jpg", cap: "Backstage with the 21 Savage tour crew", tid: "proof-photo-crew", cls: "h-56 w-full object-cover object-center" },
  { src: "/images/ariane-sofi-tukker.jpg", cap: "Backstage with Sofi Tukker", tid: "proof-photo-sofi-tukker", cls: "h-56 w-full object-cover object-center" },
];

export const Proof = () => (
  <section id="proof" className="relative py-24 lg:py-32 bg-ink2/50 border-y border-white/10" data-testid="proof-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Backstage proof"
        title={<>Where the work <em className="italic text-gold">happened</em>.</>}
        sub="Working with athletes and artists backstage since 2013 — including six years on the road touring. Recovery rooms, arena backstage corridors, film-set trailers. This is a partial list, documented."
      />

      <FadeUp className="mt-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 items-start">
          {SHOTS.map((s) => (
            <figure key={s.tid} className="group relative overflow-hidden rounded-xl border border-white/10" data-testid={s.tid}>
              <img src={s.src} alt={s.cap} loading="lazy" className={`${s.cls} transition-transform duration-700 group-hover:scale-105`} />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/10 to-transparent" aria-hidden="true" />
              <figcaption className="absolute bottom-3 left-4 right-4 font-mono text-[9px] uppercase tracking-[0.18em] text-ivory/80">
                {s.cap}
              </figcaption>
            </figure>
          ))}
        </div>
      </FadeUp>

      <div className="mt-16 space-y-12">
        {WALLS.map((w, wi) => (
          <FadeUp key={w.label} delay={wi * 0.05}>
            <p className="eyebrow mb-5">{w.label}</p>
            <div className="flex flex-wrap gap-x-6 gap-y-2" data-testid={w.testid}>
              {w.names.map((n) => (
                <span
                  key={n}
                  className={`cursor-default transition-colors duration-300 ${n.startsWith("…") || n === "and more" ? "font-serif italic text-lg sm:text-xl text-gold/80" : "font-serif text-xl sm:text-2xl font-light text-ivory/60 hover:text-gold"}`}
                >
                  {n}
                </span>
              ))}
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
